import {
  formatearFecha,
  obtenerDescripcion,
  obtenerEmpresa,
  urlApi,
} from "../../helpers/functionHelpers";
import useDropdownData from "../../hooks/useDropdownData";
import Spinner from "../Spinner";
import useEmail from "../../hooks/useEmail";
import { emailInfoProveedor } from "../../utils/email/emailInfoProveedor";

const ResumenProveedor = ({
  formData,
  setFormData,
  folio,
}) => {
  const { data: empresas, loading: loadingEmpresas } = useDropdownData(
    `${urlApi}/api/empresas`
  );
  const { data: contenedores, loading: loadingContenedores } = useDropdownData(
    `${urlApi}/api/contenedores`
  );
  const { data: condiciones, loading: loadingCondiciones } = useDropdownData(
    `${urlApi}/api/condiciones`
  );
  const { data: unidades, loading: loadingUnidades } = useDropdownData(
    `${urlApi}/api/unidades`,
    setFormData,
    formData.undmdas_id,
    true
  );
  const { sendEmail, isSending, error, success } = useEmail();

  const handleSendEmailButton = () => {
    const templateParams = {
      to_name: formData?.nombrePrv,
      to_email: formData?.correoPrv,
      to_phone: formData?.telefonoPrv,
      to_company: formData?.compania,
      to_date: formData?.fechaRsv
        ? formatearFecha(formData?.fechaRsv)
        : "No disponible",
      to_numOC: formData?.numeroOC,
      to_numFac: formData?.numFac,
      to_numIn: formData?.nmInsumo,
      to_cant: formData?.cantidad,
      to_undmds: formData?.undmdas_id
        ? obtenerDescripcion(formData?.undmdas_id, unidades)
        : "No disponible",
      to_container: formData?.containers_id
        ? obtenerDescripcion(formData?.containers_id, contenedores)
        : "No disponible",
      to_numContainers: formData.numeroCntdr,
      to_weight: formData.pesoOcantidad,
      to_numPallets: formData.numeroPallets,
      to_alm: formData?.conditions_id
        ? obtenerDescripcion(formData?.conditions_id, condiciones)
        : "No disponible",
      message: formData?.comentariosPrv,
      folio: formData?.folio,
    };
    const html = emailInfoProveedor(templateParams);
    sendEmail({
      to: templateParams.to_email,
      subject: "Email transportista Sanfer",
      html,
    });
  };

  if (
    loadingUnidades ||
    loadingContenedores ||
    loadingCondiciones ||
    loadingEmpresas
  ) {
    return (
      <div className="loader-container">
        <div className="spinner-wrapper">
          <Spinner />
          <p className="loading-text">Cargando datos...</p>
        </div>
      </div>
    );
  }
  return (
    <div className="summary-container">
      <header className="summary-header">
        <h1>Datos del proveedor folio: {folio}</h1>
      </header>
      <div className="summary-details">
        <div className="summary-item">
          <strong>Nombre del proveedor:</strong> {formData?.nombrePrv}
        </div>
        <div className="summary-item">
          <strong>Correo del proveedor:</strong> {formData?.correoPrv}
        </div>
        <div className="summary-item">
          <strong>Teléfono del proveedor:</strong> {formData?.telefonoPrv}
        </div>
        <div className="summary-item">
          <strong>Compañía:</strong> {formData?.compania}
        </div>
        <div className="summary-item">
          <strong>Fecha de Reserva:</strong>{" "}
          {formData?.fechaRsv
            ? formatearFecha(formData?.fechaRsv)
            : "No disponible"}
        </div>
        <div className="summary-item">
          <strong>Número de OC:</strong> {formData?.numeroOC}
        </div>
        <div className="summary-item">
          <strong>Número de Factura:</strong> {formData?.numFac}
        </div>
        <div className="summary-item">
          <strong>Nombre del Insumo:</strong> {formData?.nmInsumo}
        </div>
        <div className="summary-item">
          <strong>Cantidad:</strong> {formData?.cantidad}
        </div>
        <div className="summary-item">
          <strong>Unidad de Medida:</strong>{" "}
          {formData?.undmdas_id
            ? obtenerDescripcion(formData?.undmdas_id, unidades)
            : "No disponible"}
        </div>
        <div className="summary-item">
          <strong>Contenedor:</strong>{" "}
          {formData?.containers_id
            ? obtenerDescripcion(formData?.containers_id, contenedores)
            : "No disponible"}
        </div>
        <div className="summary-item">
          <strong>Número de Contenedores:</strong> {formData?.numeroCntdr}
        </div>
        <div className="summary-item">
          <strong>Peso por contenedor:</strong> {formData?.pesoOcantidad}
        </div>
        <div className="summary-item">
          <strong>Número de Pallets:</strong> {formData?.numeroPallets}
        </div>
        <div className="summary-item">
          <strong>Condiciones de Almacenamiento:</strong>{" "}
          {formData?.conditions_id
            ? obtenerDescripcion(formData?.conditions_id, condiciones)
            : "No disponible"}
        </div>
        <div className="summary-item">
          <strong>Empresa seleccionada:</strong>{" "}
          {formData?.empresas_id
            ? obtenerEmpresa(formData?.empresas_id, empresas)
            : "No disponible"}
        </div>
        <div className="summary-item">
          <strong>Comentarios:</strong> {formData?.comentariosPrv}
        </div>
        {formData.extras?.materialSanfer && (
          <div className="summary-item">
            <strong>Código de material Sanfer:</strong> {formData.extras.materialSanfer}
          </div>
        )}
        {formData.extras?.probiomedInterna && (
          <div className="summary-item">
            <strong>Almacén Probiomed Interna:</strong> {formData.extras.probiomedInterna}
          </div>
        )}
        <div>
          {isSending && <p className="status-message">Enviando correo...</p>}
          {success && (
            <p className="status-message success">¡Correo enviado con éxito!</p>
          )}
          {error && (
            <p className="status-message error">
              Hubo un error al enviar el correo
            </p>
          )}
          <button
            className="submit-button"
            onClick={handleSendEmailButton}
            disabled={isSending}
          >
            {isSending ? "Enviando..." : "Enviar por Correo"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResumenProveedor;
